export default __webpack_public_path__ + "static/media/sb.076350fb.svg";